import {api} from '../../constants'

export const toAbsoluteUrl = (pathname: string) => `${process.env.PUBLIC_URL}${pathname}`
export const toImageUrl = (pathname: string) => `${api.filesRoot}/appData/${pathname}`
